// ////////////////////////////スマホ/タブレット判別
var _ua = (function (u) {
  return {
    Tablet: (u.indexOf('windows') != -1 && u.indexOf('touch') != -1)
      || u.indexOf('ipad') != -1
      || (u.indexOf('android') != -1 && u.indexOf('mobile') == -1)
      || (u.indexOf('firefox') != -1 && u.indexOf('tablet') != -1)
      || u.indexOf('kindle') != -1
      || u.indexOf('silk') != -1
      || u.indexOf('playbook') != -1,
    Mobile: (u.indexOf('windows') != -1 && u.indexOf('phone') != -1)
      || u.indexOf('iphone') != -1
      || u.indexOf('ipod') != -1
      || (u.indexOf('android') != -1 && u.indexOf('mobile') != -1)
      || (u.indexOf('firefox') != -1 && u.indexOf('mobile') != -1)
      || u.indexOf('blackberry') != -1
  };
})(window.navigator.userAgent.toLowerCase());
// if(_ua.Mobile){}

var osVer;
osVer = 'Android';

// if (navigator.userAgent.indexOf(osVer)>0){
// }

var breakNum = 768;
var tabletNum = 1024;
// ////////////////////////////////////init
$(function () {
  setScroll();
  // setHeader()
  // killClick()
  if ($('#wrapper').hasClass('home')) {
    setLang();
    setLoadingImg();
  }
  // ///////////
  if (_ua.Tablet || _ua.Mobile) {} else {}
  // ///////////
  if (!_ua.Mobile) {}
});

$(window).on('load', function () {
  heightLineGroup();
  svg4everybody();
  judgeWinSize();
  setMainMenu();
  setModalMenu();
  setLoaded();
  setHeader();
  setSearch();
  setAcc();
  setWay();
  // var ua = window.navigator.userAgent.toLowerCase()
  // if (ua.indexOf('windows nt') !== -1) {
  // } else {
  //   setLuxy()
  // }
  // setScrollTop()
  // setTextile()
  if ($('#wrapper').hasClass('home')) {
    // setMainVis()
  }
  if (!_ua.Mobile && !_ua.Tablet) {
    // setPal()
  }
});

// 言語スイッチ
function setLang () {
  $('#wrapper').addClass('localEn');
  $('.langSwitch a').on('click', function () {
    var langFlag = $(this).parent().attr('class');
    $('.langSwitch a').removeClass('current');
    if (langFlag == 'jaSw') {
      $(this).addClass('current');
      $('#wrapper').removeClass('localEn');
      $('#wrapper').addClass('localJa');
    }else {
      $(this).addClass('current');
      $('#wrapper').removeClass('localJa');
      $('#wrapper').addClass('localEn');
    }
  });
}

// ///////////////////////////パララックス
function setLuxy () {
  $('#wrapper').addClass('setLuxy');
  luxy.init({
    wrapper: '#outerMenu',
    // targets: '.pal',
    // wrapperSpeed: 0.08
    wrapperSpeed: 0.09
  });
}

// フォーム制御
function setForm () {
  // URLのアンカー（#以降の部分）を取得
  var urlHash = location.hash;

  // URLにアンカーが存在する場合
  if (urlHash) {
    if (urlHash == '#studio') {
      $('[value="スタジオのご利用について"]').prop('checked', true);
      $('.productInput').hide();
    }else {
      urlHash = urlHash.replace('#', '');
      $('[name="productnum"]').val(urlHash);
    }
  }

  $('[name="subject"]:radio').change(function () {
    if ($('[value="家具について"]').prop('checked') || $('[value="アート&プロップスについて"]').prop('checked')) {
      $('.productInput').fadeIn('fast');
    } else {
      $('.productInput').hide();
      $('[name="productnum"]').val('');
    }
  });

  $('.radioStyle_01 .wpcf7-list-item .wpcf7-list-item-label').each(function () {
    $(this).prepend('<span>&nbsp;</span>');
  });

  $('.wpcf7-tel').attr('pattern', '\\d*');
  $('.wpcf7-tel').attr('onkeyup', 'if(event.keyCode==9||event.keyCode==16) return; this.value=this.value.replace(/[^0-9]+/i,"")');
  $('#confirmBtn').on('click', function () {
    $('.wpcf7c-btn-confirm').click();
  });
  $('#backBtn').on('click', function () {
    $('.wpcf7c-btn-back').click();
  });
  $('#submitBtn').on('click', function () {
    $('.wpcf7-submit').click();
  });

  // /////エラーのとき
  document.addEventListener('wpcf7invalid', function (event) {
    setTimeout(function () {
      var position = $('.wpcf7-not-valid-tip:first').offset().top;
      $('html,body').animate({
        scrollTop: 0
      }, {
        queue: false
      });
    }, 100);
  }, false);
  // /////成功のとき
  document.addEventListener('wpcf7mailsent', function (event) {
    $('html,body').animate({
      scrollTop: 0
    }, {
      queue: false
    });
  }, false);
}

// ///////////////////////////フォーム確認画面
function setConfirm () {
  var tx = $('[name=subject]').val();
  $('#catTx').text(tx);

  var tx = $('[name=productnum]').val();
  $('#noTx').text(tx);

  var tx = $('[name=myname]').val();
  $('#nameTx').text(tx);

  var tx = $('[name=company-name]').val();
  $('#companyTx').text(tx);

  var tx = $('[name=mytel]').val();
  $('#telTx').text(tx);

  var tx = $('[name=mymail]').val();
  $('#mailTx').text(tx);

  var tx = $('[name=subject-type]').val();
  $('#typeTx').text(tx);

  var tx = $('[name=comment]').val();
  $('#commentTx').text(tx);
}

// プロダクトナビのカレント
function setCurrentNav () {
  // $('.all').find('a').removeClass('current')
  // $('.sample').find('a').addClass('active')
  $('#nav-side li').each(function () {
    if ($(this).find('a').hasClass('active')) {
      $(this).addClass('active');
      $(this).find('.child').slideDown('fast');
    }
  });
}

// ////////////////////////////プロダクトナビアコーディオン
function setProductNav () {
  $('#nav-side .display .wrap').on('click', function () {
    var searchWord = $(this).find('.label').text();
    if ($('#wrapper').hasClass('setSp')) {
      if ($('#wrapper').hasClass('search')) {
        openFnc();
        $('#menuPanel .searchComp').addClass('active');
        $('#menuPanel').addClass('searchActive');
        $('#menuPanel .searchComp').find('input').focus();
        $('#menuPanel .searchComp').find('input').val(searchWord);
      }else {
        var target = '#' + $(this).attr('class').replace('wrap ', '');
        $(this).parent().hide();
        $(this).parents('#nav-side').find('li').removeClass('active');
        $(this).parents('#nav-side').find('.child').hide();
        $(this).parents('#nav-side').find('li').not('.display').slideDown('fast');
        $(this).parents('#nav-side').find('.all').addClass('active');
        if (target) {
          $(target).addClass('active');
          $(target).find('.child').slideDown('fast');
        }
      }
    }
  });
  $('#nav-side .searchWord').on('click', function () {
    var searchWord = $(this).find('.label').text();
    if ($('#wrapper').hasClass('setPc')) {
      $('body,html').animate({
        scrollTop: 0
      }, 100);
      if (!$(this).hasClass('active')) {
        $('header .searchComp').addClass('active');
        $('header .searchComp').find('input').focus();
        $('header .searchComp').find('input').val(searchWord);
        $('#menuPanel').addClass('searchActive');
        $(this).addClass('active');
      }else {
        $('header .searchComp').find('input').focus();
        $('header .searchComp').find('input').val(searchWord);
      // $('header .searchComp').removeClass('active')
      // $('#menuPanel').removeClass('searchActive')
      // $(this).removeClass('active')
      }
    }
  });
  $('#nav-side .all .wrap').on('click', function () {
    if ($('#wrapper').hasClass('setSp')) {
      $(this).parents('#nav-side').find('li').removeClass('active');
      $(this).parents('#nav-side').find('li').not('.display').hide();
      $(this).parents('#nav-side').find('.display').show();
    }
  });
}

// フローティングナビ
function setFloating () {
  var floatingPos = $(window).scrollTop();
  // var startPos = $('#startPos').offset().top
  // var startPos = 10
  setTimeout(function () {
    if ($('.floatingNav').height() > $('.col-main').height()) {
      $('.floatingNav').addClass('static');
    }else {
      $('.floatingNav').addClass('floating');
    }
  }, 800);

  var endPos = $('#endPos').offset().top - $('.floatingNav').height() - 80;
  $(window).scroll(function () {
    endPos = $('#endPos').offset().top - $('.floatingNav').height() - 80;
    if ($(this).scrollTop() > endPos) {
      $('.floatingNav').addClass('endFloating');
    }else {
      $('.floatingNav').removeClass('endFloating');
    }
  });

// var timeoutId
// window.addEventListener('scroll', function () {
//   floatingPos = $(window).scrollTop()
//   if ($('#wrapper').hasClass('setPc')) {
//     // スクロールを停止して500ms後に終了とする
//     clearTimeout(timeoutId)
//     timeoutId = setTimeout(function () {
//       if ($(this).scrollTop() > endPos) {
//         $('.floatingNav').addClass('endFloating')
//         $('.floatingNav').css('top', 'auto')
//       }else {
//         $('.floatingNav').removeClass('endFloating')
//         $('.floatingNav').stop().animate({
//           'top': floatingPos
//         }, { duration: 'fast', easing: 'swing' })
//       }
//     }, 500)
//   }
// })
}

// ///////ヘッダー制御
function setHeader () {
  fixedHeader();

  $(window).scroll(function () {
    fixedHeader();
  });

  var winW = $(window).width();
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    winW = $(window).width();
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      $('#wrapper').removeClass('fixedHeader');
    }, 200);
  });

  var hsize = $('header').innerHeight(); // paddingを含めた高さを取得
  var pos = 0;
  function fixedHeader () {
    var currentPos = $(this).scrollTop();
    if (currentPos < pos) {
      $('#wrapper').addClass('fixedHeader');
      var h = 100;
      if ($(this).scrollTop() <= h) {
        $('#wrapper').removeClass('fixedHeader');
      }
    }else {
      $('#wrapper').removeClass('fixedHeader');
    }
    pos = currentPos; // 現在地保存

    var h = 100;
    if ($(this).scrollTop() <= h) {
      $('#wrapper').removeClass('setHeader');
    }else if ($(this).scrollTop() > h) {
      $('#wrapper').addClass('setHeader');
    }
  }

// function fixedHeader () {
//   var h = 10
//   // if ($('#wrapper').hasClass('home')) {
//   //   h = $('#mainVis').height()
//   // }else {
//   //   h = $('.subHeader').height()
//   // }
//   baseHeight = h
//   if ($(this).scrollTop() <= baseHeight) {
//     $('#wrapper').removeClass('fixedHeader')
//   }else if ($(this).scrollTop() > baseHeight) {
//     $('#wrapper').addClass('fixedHeader')
//   }
// }
}

// 検索窓
function setSearch () {
  // enterでモックリンク
  // $('#searchInput').keypress(function (e) {
  //   if (e.which == 13) {
  //     window.location.href = 'search.html'
  //     return false
  //   }
  // })
  $('.searchComp .icon span').on('click', function () {
    if ($(this).parents('.searchComp').hasClass('active')) {
      $(this).parents('form').submit();
    // submit
    }else {
      $(this).parents('.searchComp').addClass('active');
      $(this).parents('.searchComp').find('input').focus();
      $('#menuPanel').addClass('searchActive');
    }
  });
  $('.searchComp .inputCloseBtn').on('click', function () {
    $('#menuPanel .iconNav').addClass('hideEff');
    $(this).parents('.searchComp').find('input').val('');
    $(this).parents('.searchComp').removeClass('active');
    $('#menuPanel').removeClass('searchActive');
    setTimeout(function () {
      $('#menuPanel .iconNav').removeClass('hideEff');
    }, 500);
  });
}

// //////////////////////////メインメニュー
var current_scrollY;
function setMainMenu () {
  $('#menuBtn').on('click', function () {
    if (!$(this).hasClass('active')) {
      openFnc();
    }else {
      closeFnc();
    }
  });

  $('#clickBlocker').on('click', function () {
    closeFnc();
  });
  $('.headBlock').on('click', function () {
    if ($('#wrapper').hasClass('menuOpen')) {
      closeFnc();
    }
  });

  var winW = $(window).width();
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    winW = $(window).width();
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      if (winW > tabletNum) {
        closeFnc();
        closeModal();
      }
    }, 200);
  });
}

function openFnc () {
  current_scrollY = $(window).scrollTop();
  $('body').addClass('breakH');
  $('#menuBtn').addClass('active');
  $('#wrapper').addClass('menuOpen');
  $('#outerMenu').css('top', -(current_scrollY));
  $('#menuPanel .iconNav').addClass('hideEff');
  setTimeout(function () {
    $('html, body').prop({
      scrollTop: 0
    });
  }, 100);
  setTimeout(function () {
    $('#menuPanel .iconNav').removeClass('hideEff');
  }, 300);
}

function closeFnc () {
  $('body').removeClass('breakH');
  $('#wrapper').addClass('breakLuxy');
  $('#menuBtn').removeClass('active');
  $('#outerMenu').css('top', '');
  $('#wrapper').removeClass('menuOpen');
  $('.searchComp').find('input').val('');
  $('.searchComp').removeClass('active');
  $('#menuPanel').removeClass('searchActive');
  $('html, body').prop({
    scrollTop: current_scrollY
  });
  setTimeout(function () {
    $('#wrapper').removeClass('breakLuxy');
  }, 800);
}

// モーダル制御
function setModalMenu () {
  $('.modalBtn').on('click', function () {
    if ($('#wrapper').hasClass('setSp')) {
      if (!$('#modalBurger').hasClass('active')) {
        openModal();
      }
    }
  });
  $('#modalBurger').on('click', function () {
    if ($('#modalBurger').hasClass('active')) {
      closeModal();
    }
  });
}

function openModal () {
  $('body').addClass('breakH');
  current_scrollY = $(window).scrollTop();
  $('#modalBurger').addClass('active');
  $('#wrapper').addClass('modalOpen');
  $('#outerMenu').css('top', -(current_scrollY));
  setTimeout(function () {
    $('html, body').prop({
      scrollTop: 0
    });
  }, 100);
}

function closeModal () {
  $('body').removeClass('breakH');
  $('#wrapper').addClass('breakLuxy');
  $('#modalBurger').removeClass('active');
  $('#outerMenu').css('top', '');
  $('#wrapper').removeClass('modalOpen');
  $('html, body').prop({
    scrollTop: current_scrollY
  });
  setTimeout(function () {
    $('#wrapper').removeClass('breakLuxy');
  }, 800);
}

var randomStart = 0;
// /ローディング画像セット
function setLoadingImg () {
  $('#loading').addClass('home');
  var imgCount = $('#loading .imgStyle').length;
  randomStart = Math.floor(Math.random() * imgCount) + 1;
  var target = '#loading .imgStyle:nth-child(' + randomStart + ')';
  $(target).addClass('show');
}

// ////////////////////////////スライダー
function setCarousel00 () {
  var target = '.carouselStyle_01';
  $(target).each(function () {
    var slider = $(this).find('.screen');
    var slideCount = $(this).find('.screen>.carouselItem').length;
    var baseCount = slideCount + 1;
    console.log(randomStart);
    randomStart = randomStart - 1;
    if (baseCount > 2) {
      slider.slick({
        initialSlide: randomStart,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
        speed: 1000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        cssEase: 'cubic-bezier(.645, .045, .355, 1)'
      });
    }
    slider.on('touchmove', function (event, slick, currentSlide, nextSlide) {
      slider.slick('slickPlay');
    });

    var timer = false;
    var currentWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (currentWidth == window.innerWidth) {
        return;
      }
      currentWidth = window.innerWidth;
      if (timer !== false) {
        clearTimeout(timer);
      }
      timer = setTimeout(function () {
        slider.slick('slickPlay');
      }, 200);
    });
  });
}

function setCarousel01 () {
  var target = '.carouselStyle_01';
  $(target).each(function () {
    var slider = $(this).find('.screen');
    var slideCount = $(this).find('.screen>.carouselItem').length;
    var baseCount = slideCount + 1;
    var randomStart = Math.floor(Math.random() * slideCount);
    if (baseCount > 2) {
      slider.slick({
        initialSlide: randomStart,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
        speed: 1000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        cssEase: 'cubic-bezier(.645, .045, .355, 1)'
      });
    }
    slider.on('touchmove', function (event, slick, currentSlide, nextSlide) {
      slider.slick('slickPlay');
    });

    var timer = false;
    var currentWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (currentWidth == window.innerWidth) {
        return;
      }
      currentWidth = window.innerWidth;
      if (timer !== false) {
        clearTimeout(timer);
      }
      timer = setTimeout(function () {
        slider.slick('slickPlay');
      }, 200);
    });
  });
}

function setCarousel02 () {
  var target = '.carouselStyle_02';
  $(target).each(function () {
    var slider = $(this).find('.screen');
    var slideCount = $(this).find('.screen>.carouselItem').length;
    var baseCount = slideCount + 1;
    var navigation = $(this).find('.slideNav .item');
    var navigationWrap = $(this).find('.slideNav');
    if (baseCount > 2) {
      slider.slick({
        dots: false,
        infinite: true,
        autoplay: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        cssEase: 'linear'
      });
      navigation.each(function (index) { // サムネイルに連番付与属性
        $(this).attr('data-number', index);
      });

      navigation.on('click', function () { // サムネイルクリック時イベント
        var number = $(this).attr('data-number');
        slider.slick('slickGoTo', number, false);
      });

      slider.on('afterChange', function () {
        var currentSlide = slider.slick('slickCurrentSlide');
        navigation.siblings().removeClass('active');
        navigation.eq(currentSlide).addClass('active');
        var navW = navigation.find('.itemImg:first-child').width();
        var posX = navW * (currentSlide);
        navigationWrap.animate({scrollLeft: posX});
      });
    }
  });
}
// ////////////////////////////アコーディオン
function setAcc () {
  $('.navStyle_01 .hasChild .wrap').on('click', function () {
    $(this).parent().toggleClass('active');
    $(this).next().slideToggle('fast');
  });
  $('.navStyle_01 .hasChild .wrap>a').click(function (event) {
    event.stopPropagation();
  });

  $('.accStyle_01 .accTtl').on('click', function () {
    if ($('#wrapper').hasClass('setSp')) {
      $(this).toggleClass('active');
      $(this).next().slideToggle('fast');
    }
  });
}

// ////////////ウィンドウサイズを判別
function judgeWinSize () {
  var winW = $(window).width();
  if (winW > breakNum) {
    $('#wrapper').addClass('setPc');
  } else {
    $('#wrapper').addClass('setSp');
  }

  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      winW = $(window).width();
      if (winW > breakNum) {
        $('#wrapper').addClass('setPc');
        $('#wrapper').removeClass('setSp');
      } else {
        $('#wrapper').addClass('setSp');
        $('#wrapper').removeClass('setPc');
      }
    }, 200);
  });
}

// //////////////////////////////ロード完了
function setLoaded () {
  $('#loading').addClass('loaded');
  if (!$('#wrapper').hasClass('home')) {
    loadStart();
  }else {
    timer = setTimeout(function () {
      $('#loading').addClass('logoStart');
    }, 2000);
    timer = setTimeout(function () {
      $('#loading').addClass('loadEnd');
      $('#wrapper').addClass('homeStart');
      loadStart();
      setCarousel00();
    }, 4000);
    timer = setTimeout(function () {
      $('#wrapper').addClass('logoStart');
    }, 4500);
  }
}

function loadStart () {
  $('#wrapper').addClass('loaded');
  setGnav();
  timer = setTimeout(function () {
    $('#wrapper').addClass('loadedDone');
  }, 3000);
  $('body,html').animate({
    scrollTop: 0
  }, 0, 'swing');
}

function setGnav () {
  var i = 0;
  setInterval(function () {
    $('#headNav li').eq(i).addClass('start');
    i++;
    if (i >= $('#headNav li').length) i = 0;
  }, 100);
}

// ///////waypoint
function setWay () {
  $('.way,.alphaWay,.scaleWay,.setAnimation,#bgTx>div,.nullWay,.imgStyle_01').waypoint(function (direction) {
    var activePoint = $(this.element);
    if (direction === 'down') { // scroll down
      activePoint.addClass('active');
      timer = setTimeout(function () {
        activePoint.addClass('activeAfter');
      }, 1000);
    }
  //    else{ //scroll up
  //        activePoint.removeClass('active')
  //    }
  }, {
    offset: '70%'
  });

  $('.shuffle').waypoint(function (direction) {
    var activePoint = $(this.element);
    if (direction === 'down') { // scroll down
      activePoint.addClass('active');
      // var container = $(this.element)
      activePoint.shuffleLetters();
    }
  //    else{ //scroll up
  //        activePoint.removeClass('active')
  //    }
  }, {
    offset: '70%'
  });

  $('.ttlStyle_05,.fade_01,.fade_02').waypoint(function (direction) {
    var activePoint = $(this.element);
    if (direction === 'down') { // scroll down
      activePoint.addClass('active');
    }
  //    else{ //scroll up
  //        activePoint.removeClass('active')
  //    }
  }, {
    offset: '70%'
  });
}

// /////////////////////////////スムーススクロール
function setScroll () {
  $('a[href^="#"]').click(function () {
    if (!$(this).hasClass('crNav')) {
      // スクロールの速度
      var speed = 400; // ミリ秒
      // アンカーの値取得
      var href = $(this).attr('href');
      // 移動先を取得
      var target = $(href == '#' || href == '' ? 'html' : href);
      // 移動先を数値で取得
      if (!_ua.Mobile) {
        var position = target.offset().top - 80;
      } else {
        var position = target.offset().top - $('header').height() - 40;
      }
      if ($(this).hasClass('unqNav') && $('#wrapper').hasClass('setSp')) {
        if ($(this).hasClass('aboutPos')) {
          position = aboutPos;
        }else {
          position = missionPos;
        }
        closeFnc(position);
        return false;
      } else {
        // スムーススクロール
        $('body,html').animate({
          scrollTop: position
        }, speed, 'swing');
        return false;
      }
    }
  });
}

function startScroll () {
  // var headerHight = 1000
  var headerHight = $('header').height();
  var href = $(location).attr('hash');
  if (href) {
    var target = $(href == '#' || href == '' ? 'html' : href);
    var position = target.offset().top - headerHight;

    $.when(
      $('html, body').animate({
        scrollTop: position
      }, 400, 'swing')
    ).done(function () {
      var diff = target.offset().top - headerHight;
      if (diff === position) {
      } else {
        $('html, body').animate({
          scrollTop: diff
        }, 10, 'swing');
      }
    });
  }
}

// ////////////////////////////////////ランドスケープ判定
var isLandscape = function () {
  if (window.innerHeight > window.innerWidth) {
    jQuery('body').addClass('portrait');
    jQuery('body').removeClass('landscape');
  } else {
    jQuery('body').addClass('landscape');
    jQuery('body').removeClass('portrait');
  }
};

if (_ua.Mobile) {
  jQuery(window).resize(function () {
    isLandscape();
  });
  isLandscape();
}

// //////////////////////////////高さ揃え
function heightLineGroup () {
  // setAutoHeight('#photoDiary .articleStyle_02 .inner')
  var winW = $(window).width();
  if (winW > breakNum) {
    setAutoHeight('.carouselStyle_02 .navSec .item');
  // setAutoHeight('.setH_01 h2')
  // setAutoHeight('#photoDiary .articleStyle_02 .inner')
  // setAutoHeight(".setH_01 .summary",3)
  } else {
    // setAutoHeight("#setH_08 h2",2)
  }

  startResize();
}

function setAutoHeight (target, count) {
  $(target).tile(count);
}

function startResize () {
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      heightLineGroup();
    }, 200);
  });
}
